/**
 * Single source of truth for column configuration versions.
 * Bump a section's version whenever its column list changes.
 * Both columnVersionManager and userPreferenceManger import from here
 * to avoid a circular dependency between those two files.
 */
export const CURRENT_VERSIONS = {
  inventory: 8,
  "ma-inventory": 12,
  "order_0-0": 8,
  "order_0-1": 5,
  "order_0-2": 4,
  // 19 -> 20: List ID column added to the orders blotter (columnConfigUtils.buildOrderColumns).
  // Without this bump, anyone who has ever customised their columns keeps the stored set and
  // never sees the new one - see the note at the top of columnVersionManager.
  // 20 -> 21: List Name column added next to List ID, same reason.
  "order_1-0": 21,
  bondLadder: 7,
  "account-positions": 8,
  "portfolio-rebalance": 7,
  "order-preview": 9,
  "portfolio-play": 5,
  "sec-master": 4,
  "counter-parties": 1,
  "quickfix-messages": 1,
  sessionConfig: 2,
  userConfig: 2,
  ediFileProcess: 2,
};
